// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2w6c2","header":"MessagesList_header__1G-FN","chat":"MessagesList_chat__QXAiK"};